module.exports = __webpack_public_path__ + "static/img/banner13.6011c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner13.png
// module id = LRPL
// module chunks = 1